import { render, staticRenderFns } from "./StudentPeiHistory.vue?vue&type=template&id=1d7e0640&scoped=true&"
import script from "./StudentPeiHistory.vue?vue&type=script&lang=js&"
export * from "./StudentPeiHistory.vue?vue&type=script&lang=js&"
import style0 from "./StudentPeiHistory.vue?vue&type=style&index=0&id=1d7e0640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7e0640",
  null
  
)

export default component.exports